import { openSecurityRequest } from '@/utils/request'

// 获取图形验证码
export function getImageCaptcha(params) {
    return openSecurityRequest.get('/open/checkCode', {
        params
    })
}

// 获取图形验证码,登录用
export function getLoginImageCaptcha(params) {
    return openSecurityRequest.get('/open/v2/login/getCheckCode', {
        params
    })
}

// 获取密码编码key
export function getPasswordEncodeKey(params) {
    return openSecurityRequest.post('/open/getEncryptKey', {
        params
    })
}

// 发送ERP手机验证码
export function sendSmsCode(params) {
    return openSecurityRequest.get('/open/sendSmsCodeByType', {
        params
    })
}

// 注册发送ERP手机验证码
export function sendRegisterSmsCode(params) {
    return openSecurityRequest.get('/open/register/sendSmsCode', {
        params
    })
}

// 发送手机验证码V2
export function sendSmsCodeV2(params) {
    return openSecurityRequest.get('/open/v2/login/sendSmsCode', {
        params
    })
}

// 发送短信是否需要图形验证码
export function needVerifyCodeForSendSms(params) {
    return openSecurityRequest.get('/open/needVerifyCodeForSendSms', {
        params
    })
}

export function getIdaasVerificationCode(params) {
    return openSecurityRequest.get(`/open/v2/login/gyl/getIdaasVerificationCode`, { params })
}

// 未登录,手机号绑定发送短信接口
export function sendSmsForBind(params) {
    return openSecurityRequest.get('/open/v2/login/sendSmsForBind', {
        params
    })
}
